import React, { PureComponent } from 'react'

export const BREAKPOINTS = {
  XL: 'XL',
  LG: 'LG',
  MD: 'MD',
  SM: 'SM',
  XS: 'XS',
}

export default (ComposedComponent) => {
  class WithWindowBreakpoint extends PureComponent {
    constructor(props) {
      super(props)
      this.updateWindowSize = this.updateWindowSize.bind(this)
      this.state = {
        winBreakpoint: null,
      }
    }
    UNSAFE_componentWillMount() {
      this.updateWindowSize()
    }
    componentDidMount() {
      if(window) {
        window.addEventListener('resize', this.updateWindowSize)
      }
    }
    componentWillUnmount() {
      if(window) window.removeEventListener('resize', this.updateWindowSize)
    }

    updateWindowSize() {
      if(window) {
        const currentWidth = window.innerWidth
        let currentBreakpoint
        switch(true) {
          case currentWidth > 1240:
            currentBreakpoint = BREAKPOINTS.XL
            break
          case currentWidth > 1160:
            currentBreakpoint = BREAKPOINTS.LG
            break
          case currentWidth > 767:
            currentBreakpoint = BREAKPOINTS.MD
            break
          case currentWidth > 414:
            currentBreakpoint = BREAKPOINTS.SM
            break
          case currentWidth <= 414:
            currentBreakpoint = BREAKPOINTS.XS
            break
          default:
            currentBreakpoint = null
            break
        }
        if(currentBreakpoint !== this.state.winBreakpoint) {
          this.setState({
            winBreakpoint: currentBreakpoint,
          })
        }
      }
    }
    render() {
      return (
        <ComposedComponent
          {...this.props}
          winBreakpoint={this.state.winBreakpoint}
        />
      )
    }
  }
  WithWindowBreakpoint.displayName = ComposedComponent.displayName + ' withWindowSize' || 'WithWindowSize'
  return WithWindowBreakpoint
}
